// extracted by mini-css-extract-plugin
module.exports = {"container":"MainPage_container__15CpY"};